export enum MmbWidgetTab {
  FIND_WITH_BOOKING_REFERENCE,
  UPCOMING_TRIPS,
}
